import { render } from "./SettingCustomer.vue?vue&type=template&id=31759b64"
import script from "./SettingCustomer.vue?vue&type=script&lang=js"
export * from "./SettingCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__